import { render, staticRenderFns } from "./ProjectSummaryPreorder.vue?vue&type=template&id=0d3a6dcd"
import script from "./ProjectSummaryPreorder.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryPreorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports